// Mock catalog for BIGTIME - to be replaced with backend data later
export const CATEGORIES = [
  { id: 'relojeria', name: 'Relojería', icon: 'Watch' },
  { id: 'belleza', name: 'Belleza', icon: 'Sparkles' },
  { id: 'bolsos', name: 'Bolsos', icon: 'ShoppingBag' },
  { id: 'bandoleros', name: 'Bandoleros', icon: 'Briefcase' },
  { id: 'bisuteria', name: 'Bisutería', icon: 'Gem' },
  { id: 'accesorios', name: 'Accesorios', icon: 'Glasses' },
  { id: 'llaveros', name: 'Llaveros', icon: 'KeyRound' },
  { id: 'electronicos', name: 'Electrónicos', icon: 'Smartphone' },
  { id: 'papeleria', name: 'Papelería', icon: 'NotebookPen' },
  { id: 'skincare', name: 'Skincare', icon: 'Droplets' },
  { id: 'capilares', name: 'Productos Capilares', icon: 'Wind' },
];

const IMG = {
  reloj1: 'https://images.unsplash.com/photo-1631863552122-3072cf599a46?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
  reloj2: 'https://images.unsplash.com/photo-1617043983671-adaadcaa2460?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
  belleza1: 'https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=600',
  belleza2: 'https://images.pexels.com/photos/7290632/pexels-photo-7290632.jpeg?auto=compress&cs=tinysrgb&w=600',
  bolso1: 'https://images.unsplash.com/photo-1682745230951-8a5aa9a474a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=600',
  bolso2: 'https://images.pexels.com/photos/31929486/pexels-photo-31929486.jpeg?auto=compress&cs=tinysrgb&w=600',
  band1: 'https://images.pexels.com/photos/22432981/pexels-photo-22432981.jpeg?auto=compress&cs=tinysrgb&w=600',
  band2: 'https://images.unsplash.com/photo-1621985191560-99df9ed0564a?w=600',
  bisu1: 'https://images.unsplash.com/photo-1606760227091-3dd870d97f1d?w=600',
  bisu2: 'https://images.unsplash.com/photo-1569388330292-79cc1ec67270?w=600',
  llav1: 'https://images.pexels.com/photos/35101964/pexels-photo-35101964.jpeg?auto=compress&cs=tinysrgb&w=600',
  llav2: 'https://images.unsplash.com/photo-1575908539614-ff89490f4a78?w=600',
  elec1: 'https://images.pexels.com/photos/33797659/pexels-photo-33797659.jpeg?auto=compress&cs=tinysrgb&w=600',
  elec2: 'https://images.pexels.com/photos/14741306/pexels-photo-14741306.jpeg?auto=compress&cs=tinysrgb&w=600',
  pap1: 'https://images.unsplash.com/photo-1471107340929-a87cd0f5b5f3?w=600',
  pap2: 'https://images.unsplash.com/photo-1501618669935-18b6ecb13d6d?w=600',
  skin1: 'https://images.unsplash.com/photo-1576426863848-c21f53c60b19?w=600',
  skin2: 'https://images.pexels.com/photos/8101512/pexels-photo-8101512.jpeg?auto=compress&cs=tinysrgb&w=600',
  cap1: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=600',
  cap2: 'https://images.pexels.com/photos/13516802/pexels-photo-13516802.jpeg?auto=compress&cs=tinysrgb&w=600',
};

let nextId = 1;
const mk = (category, name, price, image, opts = {}) => ({
  id: `p${nextId++}`,
  name,
  price,
  image,
  category,
  isNew: opts.isNew || false,
  isFeatured: opts.isFeatured || false,
  description: opts.description || `${name} — Producto de calidad garantizada por BIGTIME.`,
});

export const PRODUCTS = [
  // Relojería
  mk('relojeria', 'Reloj Ultra 8 Serie Deportivo', 18.90, IMG.reloj1, { isFeatured: true, isNew: true }),
  mk('relojeria', 'Smartwatch T900 Pro Max', 22.50, IMG.reloj2, { isFeatured: true }),
  mk('relojeria', 'Reloj Análogo Clásico Cuero', 14.75, IMG.reloj1),
  mk('relojeria', 'Reloj Digital LED Sport', 9.99, IMG.reloj2, { isNew: true }),
  mk('relojeria', 'Reloj Casual Metal Dorado', 26.40, IMG.reloj1),
  mk('relojeria', 'Smartwatch Fit Band Rosa', 15.30, IMG.reloj2),

  // Belleza
  mk('belleza', 'Labial Matte Larga Duración', 4.50, IMG.belleza1, { isFeatured: true }),
  mk('belleza', 'Kit Sombras 12 Colores', 8.90, IMG.belleza2, { isNew: true }),
  mk('belleza', 'Base Líquida Cobertura Total', 7.25, IMG.belleza1),
  mk('belleza', 'Rímel Volumen Extremo', 3.80, IMG.belleza2),
  mk('belleza', 'Brochas Set 10 Piezas', 12.60, IMG.belleza1),
  mk('belleza', 'Delineador Líquido Negro', 2.99, IMG.belleza2),

  // Bolsos
  mk('bolsos', 'Bolso Tote Elegante Beige', 24.90, IMG.bolso1, { isFeatured: true }),
  mk('bolsos', 'Cartera de Mano Estampada', 18.50, IMG.bolso2, { isNew: true }),
  mk('bolsos', 'Bolso Shopper Grande Negro', 27.00, IMG.bolso1),
  mk('bolsos', 'Cartera Mini Cuero PU', 15.75, IMG.bolso2),

  // Bandoleros
  mk('bandoleros', 'Bandolera Cross Body Deportiva', 16.40, IMG.band1, { isFeatured: true }),
  mk('bandoleros', 'Bandolera Compacta Urbana', 12.90, IMG.band2, { isNew: true }),
  mk('bandoleros', 'Bandolera Piel Sintética', 19.99, IMG.band1),
  mk('bandoleros', 'Riñonera Multiuso', 8.50, IMG.band2),

  // Bisutería
  mk('bisuteria', 'Set Aretes + Collar Dorado', 6.90, IMG.bisu1, { isFeatured: true }),
  mk('bisuteria', 'Pulsera Ajustable Piedras', 4.25, IMG.bisu2),
  mk('bisuteria', 'Anillos Set 6 Piezas', 5.50, IMG.bisu1, { isNew: true }),
  mk('bisuteria', 'Collar Cadena Fina Plateada', 7.80, IMG.bisu2),

  // Accesorios
  mk('accesorios', 'Lentes de Sol Estilo Aviador', 9.90, IMG.bisu1, { isFeatured: true }),
  mk('accesorios', 'Cinturón Cuero Hebilla Metal', 11.25, IMG.bisu2),
  mk('accesorios', 'Gorra Deportiva Ajustable', 7.50, IMG.bisu1),

  // Llaveros
  mk('llaveros', 'Llavero Peluche Osito', 3.20, IMG.llav1, { isNew: true }),
  mk('llaveros', 'Llavero Metálico Personalizable', 2.50, IMG.llav2),
  mk('llaveros', 'Llavero LED Multiherramienta', 4.99, IMG.llav1),

  // Electrónicos
  mk('electronicos', 'Audífonos Bluetooth TWS Pro', 12.90, IMG.elec1, { isFeatured: true, isNew: true }),
  mk('electronicos', 'Cargador Rápido 20W USB-C', 8.50, IMG.elec2),
  mk('electronicos', 'Cable Trenzado Lightning 1m', 3.75, IMG.elec1),
  mk('electronicos', 'Power Bank 10000 mAh', 14.30, IMG.elec2),
  mk('electronicos', 'Corneta Bluetooth Portátil', 18.99, IMG.elec1),
  mk('electronicos', 'Aro de Luz LED con Trípode', 22.80, IMG.elec2),

  // Papelería
  mk('papeleria', 'Cuaderno A5 Tapa Dura Rayado', 4.50, IMG.pap1, { isFeatured: true }),
  mk('papeleria', 'Set Bolígrafos Gel 12 Colores', 5.90, IMG.pap2),
  mk('papeleria', 'Agenda 2026 Diseño Floral', 8.20, IMG.pap1, { isNew: true }),
  mk('papeleria', 'Estuche Escolar Estampado', 6.75, IMG.pap2),

  // Skincare
  mk('skincare', 'Serum Vitamina C 30ml', 11.50, IMG.skin1, { isFeatured: true, isNew: true }),
  mk('skincare', 'Crema Hidratante Facial', 9.90, IMG.skin2),
  mk('skincare', 'Protector Solar SPF 50+', 13.40, IMG.skin1),
  mk('skincare', 'Tónico Facial Ácido Hialurónico', 10.75, IMG.skin2),

  // Capilares
  mk('capilares', 'Shampoo Reparador Keratina', 8.90, IMG.cap1, { isFeatured: true }),
  mk('capilares', 'Acondicionador Argán 400ml', 9.50, IMG.cap2, { isNew: true }),
  mk('capilares', 'Mascarilla Hidratación Profunda', 11.25, IMG.cap1),
  mk('capilares', 'Aceite Capilar Nutritivo', 7.80, IMG.cap2),
];

export const BIGTIME_WHATSAPP = '584123120579'; // formato internacional para wa.me
export const BIGTIME_TAGLINE = 'Todo en un solo lugar.';
